import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { IconProps } from "./types";

export function SuccessIcon({ size, ...props }: IconProps) {
    return <CheckCircleRoundedIcon fontSize={size} {...props} />;
}
